import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ExtraTimeHeader } from 'src/app/Interfaces/hr/extra-time-header';
import { genericCustomStoreService } from 'src/app/shared/services/genericCustomStore.service';
import { CheckValidation } from 'src/app/shared/services/hr/CheckValidation.service';
import { EmployeeService } from 'src/app/shared/services/hr/employee.service';
import { ObjectsService } from 'src/app/shared/services/hr/objects.service';
import { publicSettingService } from '../../../../shared/services/hr/publicSetting';
import { TranslateService } from '@ngx-translate/core';
import { SuperComponent } from 'src/app/pages/super/super.component';
import { Observable } from 'rxjs';
import { DataShareService } from 'src/app/shared/services/data-share.service';

@Component({
  selector: 'app-add-edit-extra-time-rule-header-system',
  templateUrl: './add-edit-extra-time-rule-header-system.component.html',
  styleUrls: ['./add-edit-extra-time-rule-header-system.component.scss']
})
export class AddEditExtraTimeRuleHeaderSystemComponent extends SuperComponent implements OnInit {
  ServerError$: Observable<any> = this.DataShareService.ServerError$;
  Extraname:string='';
  Extraheaderid:number;
  Extradropdown:any=[]
  ExtraData:ExtraTimeHeader[]=[]
  dataSource:any=[];
  durationType:{}[]=[]
  TaxableStatus:{}[]=[]
   constructor(public  _publicSettingService:publicSettingService, gt:genericCustomStoreService, translate:TranslateService,
      Objects:ObjectsService,private validation:CheckValidation,public router:Router,public _EmployeeService: EmployeeService, public DataShareService: DataShareService) { 
      super(Objects,translate,gt)
      //dropdown
      gt.getdropdowndata("ExtraTimeRule").subscribe(res=>this.Extradropdown=res)
      this.durationType = Objects.durationType;
     this.TaxableStatus = Objects.TaxableStatus;
     this.validateAsync = this.validateAsync.bind(this);
     //update
     this._publicSettingService.$ACTIVE_ID.subscribe(res=>this.Extraheaderid=res)
     if(this.Extraheaderid!=0){
      this.loading=true;
       _publicSettingService.byKey("ExtraTimeRuleHeaderSystem",this.Extraheaderid).subscribe((res:ExtraTimeHeader)=>{
         this.dataSource=res.extraTimeRules
         this.Extraname=res.nameAr
       })
       this.loading=false;
     }
     else{
      gt.getdropdowndata("ExtraTimeRuleHeaderSystem","GetEmptyRecord").subscribe((res:{extraTimeRules:{}[]})=>this.dataSource=res.extraTimeRules)
    }
   }
 
   ngOnInit(): void {
    this.DataShareService.removeServerError()
   }
 
   validateAsync (params:any) {
     var id = this.Extraheaderid;
     return this.validation.asyncCheckNameValue(params.value,id,"ExtraTimeRuleHeaderSystem");
     
   }
   onFormSubmit(e:any){
     this.ExtraData=[
       {
       id:this.Extraheaderid,
       nameAr:this.Extraname,
       extraTimeRules:this.dataSource
     }
   ]
   if(this.Extraheaderid!=0){
     this._publicSettingService.update("ExtraTimeRuleHeaderSystem",this.ExtraData[0]).subscribe(res=>{
       this._publicSettingService.$ACTIVE_ReFRESH.next(true)
       this.router.navigate(['hr/ExtraHeaderWorkSystem']) 
     })
      
   }
   else{
     this._publicSettingService.add("ExtraTimeRuleHeaderSystem",this.ExtraData[0]).subscribe(res=>{
       this._publicSettingService.$ACTIVE_ReFRESH.next(true)
       this.router.navigate(['hr/ExtraHeaderWorkSystem']) 
     })
   }
   }

  //  backToMainPage(e:string){
  //   if(e=='back'){
  //     this.router.navigate(['/hr/ExtraHeaderWorkSystem'])
  //   }
  // }

 }

